export const SIDEBAR_SIZE = '5.5rem';
export const NAV_Z_INDEX = 1000;
export const NAV_SIDE_MENU_Z_INDEX = 1001;
